import React, { useEffect, useMemo, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
// import './index.css'
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { setArrow, setSelectkeys, state } from '../../../store';
import busEvent from './../../../utils/bus';
import style from './index.module.scss';

const SubMenu: React.FC = () => {
  const { t, i18n } = useTranslation(); // t用于翻译，i18n用于切换语言

  // 正确初始化语言状态并设置默认值
  const [language, setLanguage] = useState<boolean>(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === null) {
      return true; // 默认为中文
    }
    return JSON.parse(savedLanguage);
  });

  // 处理语言切换
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng); // 切换 i18n 语言
  };

  // 监听语言状态变化并应用到 i18n 实例
  useEffect(() => {
    changeLanguage(language ? 'zh' : 'en');
  }, [language]);

  // 监听 switchLanguage 事件
  useEffect(() => {
    const handler = (value: boolean) => {
      setLanguage(value);
      // 同步保存到 localStorage
      localStorage.setItem('language', JSON.stringify(value));
      // 立即应用语言切换
      changeLanguage(value ? 'zh' : 'en');
    };

    busEvent.on('switchLanguage', handler);

    // 清除事件监听
    return () => {
      busEvent.off('switchLanguage', handler);
    };
  }, []);

  // ... 其余代码保持不变 ...

  const [collapsed] = useState(false);
  const [isArrow, setIsArrow] = useState(true);
  const [openKeys, setOpenKeys] = useState([] as string[]);
  const [menuShow, setMenuShow] = useState(true);
  const [hasMenu, setHasMenu] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    busEvent.on('menuSwitch', menuSwitch);
    menuSwitch(Boolean(state.menu[state.currentMenuIndex] && state.menu[state.currentMenuIndex].children));
    setOpenKeys(state.defaultOpenKeys);
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // 点击菜单项
  const handleMenuClick: MenuProps['onClick'] = e => {
    navigate(e.key);
    setSelectkeys([e.key]);
  };

  const menuSwitch = (e: boolean) => {
    setHasMenu(e);
  };

  const handleArrowClick = () => {
    if (isArrow) {
      setMenuShow(false);
    } else {
      setTimeout(() => {
        setMenuShow(true);
      }, 300);
    }
    setArrow(!isArrow);
    setIsArrow(!isArrow);
    busEvent.emit('subMenuArrow', !isArrow);
  };

  useEffect(() => {
    setOpenKeys(state.defaultOpenKeys);
  }, []);

  const openChange = (openKeys: string[]) => {
    setOpenKeys(openKeys);
  };

  const translateItems = (items: any[]) => {
    return items.map(item => {
      const newItem = { ...item };
      newItem.label = t(item.label); // 核心翻译逻辑

      if (newItem.children) {
        newItem.children = translateItems(newItem.children);
      }
      return newItem;
    });
  };

  const translatedSubMenu = useMemo(() => {
    if (state.subMenu) {
      return translateItems(state.subMenu);
    }
    return [];
  }, [state.subMenu, t]);

  return (
    <div>
      {!hasMenu && (
        <div
          className={style['lz_sub-menu']}
          style={{ width: 0 }}>
          <Menu
            style={{ width: '136px', marginLeft: 8 }}
            defaultSelectedKeys={state.selectedKeys}
            selectedKeys={state.selectedKeys}
            // defaultOpenKeys={state.defaultOpenKeys}
            onOpenChange={openChange}
            openKeys={openKeys}
            mode="inline"
            theme="light"
            inlineCollapsed={collapsed}
            items={[]}
            className={style['lz_sub-menu-container']}
            onClick={handleMenuClick}
          />
        </div>
      )}
      {hasMenu && (
        <motion.div
          className={style['lz_sub-menu']}
          animate={{ width: isArrow ? 152 : 16 }}
          transition={{ duration: 0.3 }}>
          <div
            style={{ overflowY: 'auto', overflowX: 'hidden', height: '100%', scrollbarWidth: 'none', paddingTop: 20 }}>
            {menuShow && (
              <span
                className={style['lz_sub-menu-title']}
                style={{
                  marginLeft: `${
                    i18n.language === 'en' && (state.menu && state.menu[state.currentMenuIndex].label) === '数据看板'
                      ? 0
                      : '8px'
                  }`,
                }}>
                {(state.menu && state.menu[state.currentMenuIndex].label) === '数据看板'
                  ? t('DataDashboard')
                  : state.menu[state.currentMenuIndex].label || ''}
              </span>
            )}
            {menuShow && (
              <Menu
                style={{ width: '136px', marginLeft: 8 }}
                defaultSelectedKeys={state.selectedKeys}
                selectedKeys={state.selectedKeys}
                // defaultOpenKeys={state.defaultOpenKeys}
                onOpenChange={openChange}
                openKeys={openKeys}
                mode="inline"
                theme="light"
                inlineCollapsed={collapsed}
                items={translatedSubMenu}
                className={style['lz_sub-menu-container']}
                onClick={handleMenuClick}
              />
            )}
          </div>
          <motion.div
            className="lz_sub-menu-arrow click-element"
            onClick={handleArrowClick}
            animate={{ rotate: isArrow ? 0 : 180 }}
            whileTap={{
              rotate: 180,
            }}>
            <LeftOutlined style={{ fontSize: 'var(--text-font2)', color: 'var(--text-font-color4)' }} />
            {/* <RightOutlined /> */}
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default SubMenu;
